import { useEffect, useState } from "react";
import AppShell from "@/components/AppShell";
import LeadCard from "@/components/LeadCard";
import SafeAvatar from "@/components/SafeAvatar";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/AuthContext";
import { useNavigate } from "react-router-dom";
import { Plus, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PartHome() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [leads, setLeads] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const [{ data: l }, { data: u }] = await Promise.all([
      api.get("/leads/feed", { params: { city: user.city } }),
      api.get("/users/recent", { params: { limit: 10 } }),
    ]);
    setLeads(l); setUsers(u);
    setLoading(false);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  return (
    <AppShell role="particulier" title={`Salut ${user?.name?.split(" ")[0] || ""}`}>
      {/* CTA */}
      <button onClick={() => nav("/p/create")} className="w-full bg-brand text-white rounded-2xl p-4 mb-5 text-left tap-scale" data-testid="cta-create-request">
        <div className="flex items-center gap-4">
          <div className="h-12 w-12 rounded-2xl bg-white/15 flex items-center justify-center">
            <Plus className="w-6 h-6" />
          </div>
          <div className="flex-1">
            <div className="font-heading font-bold text-lg leading-tight">Créer une demande</div>
            <div className="text-xs text-white/80 mt-0.5">Recevez plusieurs devis sous 24h</div>
          </div>
        </div>
      </button>

      {users.length > 0 && (
        <section className="mb-5">
          <div className="flex items-center justify-between mb-2">
            <h3 className="text-sm font-heading font-bold text-ink">Nouveaux pros et clients</h3>
            <span className="text-[10px] uppercase tracking-widest text-slate2">en direct</span>
          </div>
          <div className="flex gap-2.5 overflow-x-auto scroll-hide -mx-5 px-5">
            {users.map((p) => (
              <div key={p.id} className="shrink-0 w-20 text-center">
                <div className="relative">
                  <SafeAvatar src={p.avatar} role={p.role} name={p.name} className="w-16 h-16 rounded-2xl object-cover border-2 border-white shadow" />
                  <span className={`absolute -bottom-1 -right-1 w-3 h-3 rounded-full border-2 border-white ${p.role === "pro" ? "bg-pro" : "bg-brand"}`} />
                </div>
                <div className="text-[11px] font-semibold text-ink mt-1.5 truncate">{p.name}</div>
                <div className="text-[10px] text-slate2 truncate">{p.trade_name || "Particulier"}</div>
              </div>
            ))}
          </div>
        </section>
      )}

      <section>
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-sm font-heading font-bold text-ink">Demandes récentes près de chez vous</h3>
        </div>
        <p className="text-xs text-slate2 mb-3">Découvrez ce que vos voisins demandent à {user?.city || "près de chez vous"}.</p>
        <div className="space-y-3">
          {loading && <div className="text-center py-10 text-slate2 text-sm">Chargement…</div>}
          {leads.map((L) => (
            <LeadCard key={L.id} lead={L} mode="particulier" />
          ))}
        </div>
      </section>

      <button onClick={() => nav("/p/ai")} className="w-full mt-6 bg-brand-light border border-brand/30 rounded-2xl p-4 text-left tap-scale">
        <div className="flex items-center gap-3">
          <Sparkles className="w-5 h-5 text-brand" />
          <div>
            <div className="font-heading font-bold text-ink">Estimez votre projet</div>
            <div className="text-xs text-slate2">L'IA vous donne une fourchette de budget instantanée</div>
          </div>
        </div>
      </button>
    </AppShell>
  );
}
